import { getCurrentBrand } from "src/brand/currentBrand";
import { configEC } from "src/brand/EC/config";
import { BrandConfig } from "src/brand/schema";
import { BrandId } from "src/core/constants/brand";
import { useBrand } from "src/core/contexts/BrandContext";

type AnyBrandConfig = { [K in BrandId]: BrandConfig<K> }[BrandId];

const MAP = {
  EC: configEC,
} as const satisfies { [K in BrandId]: AnyBrandConfig };

export const useBrandConfig = (): AnyBrandConfig => {
  const { brand } = useBrand();
  return MAP[brand];
};

export const getBrandConfig = (): AnyBrandConfig => {
  const brand = getCurrentBrand();
  if (!brand) {
    throw new Error("Brand not found");
  }

  return MAP[brand];
};
